import { Action } from 'redux';
import { CategoryItem } from 'src/types/model';

export interface ItemCategoryState {
  loading: boolean;
  data: CategoryItem[];
  error: string | null;
}

export const FETCH_ITEM_CATEGORY_REQUEST = 'FETCH_ITEM_CATEGORY_REQUEST';
export const FETCH_ITEM_CATEGORY_SUCCESS = 'FETCH_ITEM_CATEGORY_SUCCESS';
export const FETCH_ITEM_CATEGORY_FAILURE = 'FETCH_ITEM_CATEGORY_FAILURE';

export interface FetchItemCategoryRequestAction
  extends Action<typeof FETCH_ITEM_CATEGORY_REQUEST> {}

export interface FetchItemCategorySuccessAction
  extends Action<typeof FETCH_ITEM_CATEGORY_SUCCESS> {
  payload: CategoryItem[];
}

export interface FetchItemCategoryFailureAction
  extends Action<typeof FETCH_ITEM_CATEGORY_FAILURE> {
  payload: string;
}

export type ItemCategoryActionType =
  | FetchItemCategoryRequestAction
  | FetchItemCategorySuccessAction
  | FetchItemCategoryFailureAction;
